import React from "react";
import { getValue } from "../../../utils";
import { FieldShell } from "../components/FieldShell";
import { getBaseField, objectLabel } from "../utils/valueUtils";

function getSubtableItems(row, column) {
  if (!row || !column) return [];

  const rawValue = getValue(row, column.field);

  if (Array.isArray(rawValue)) return rawValue;

  if (typeof column.field === "string" && column.field.includes(".")) {
    const baseField = getBaseField(column.field);
    const baseValue = row?.[baseField];

    if (Array.isArray(baseValue)) return baseValue;
  }

  if (Array.isArray(row?.SafetyChecks)) return row.SafetyChecks;
  if (Array.isArray(row?.safetyChecks)) return row.safetyChecks;

  return [];
}

export function PermitChecklistField({ row, label, column }) {
  const items = getSubtableItems(row, column);

  const checkLabel =
    column.subFields?.find((subField) => subField.field === "CheckPoints")
      ?.label || "Check Points";

  const responseLabel =
    column.subFields?.find((subField) => subField.field === "response")
      ?.label || "Response";

  return (
    <FieldShell
      label={label}
      column={column}
      className="safety-row-details__field--subtable"
    >
      {items.length ? (
        <div className="safety-row-details__subtable-scroll">
          <table className="safety-row-details__subtable">
            <thead>
              <tr>
                <th>{checkLabel}</th>
                <th>{responseLabel}</th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, itemIndex) => (
                <tr key={item._id ?? itemIndex}>
                  <td>{item?.CheckPoints || "—"}</td>
                  <td>{item?.response ?? "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <span className="safety-row-details__dash">—</span>
      )}
    </FieldShell>
  );
}

export function GenericSubtableField({ row, label, column }) {
  const items = getSubtableItems(row, column);
  const subFields = Array.isArray(column.subFields) ? column.subFields : [];

  return (
    <FieldShell
      label={label}
      column={column}
      className="safety-row-details__field--subtable"
    >
      {items.length && subFields.length ? (
        <div className="safety-row-details__subtable-scroll">
          <table className="safety-row-details__subtable">
            <thead>
              <tr>
                {subFields.map((subField) => (
                  <th key={subField.field}>
                    {subField.label || subField.field}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {items.map((item, itemIndex) => (
                <tr key={item._id ?? itemIndex}>
                  {subFields.map((subField) => {
                    const value = getValue(item, subField.field);

                    if (
                      subField.type === "imageLink" &&
                      typeof value === "string"
                    ) {
                      return (
                        <td key={subField.field}>
                          {value ? (
                            <img
                              src={value}
                              alt={subField.label}
                              className="safety-row-details__subtable-image"
                              onClick={() =>
                                window.open(
                                  value,
                                  "_blank",
                                  "noopener,noreferrer",
                                )
                              }
                              onError={(event) => {
                                event.currentTarget.style.display = "none";
                              }}
                            />
                          ) : (
                            "—"
                          )}
                        </td>
                      );
                    }

                    if (subField.type === "dropdown") {
                      return (
                        <td key={subField.field}>
                          {value ? (
                            <span className="safety-row-details__chip">
                              {String(value)}
                            </span>
                          ) : (
                            subField.prefilled || "—"
                          )}
                        </td>
                      );
                    }

                    if (value && typeof value === "object") {
                      return (
                        <td key={subField.field}>
                          {objectLabel(value, subField) || "—"}
                        </td>
                      );
                    }

                    return (
                      <td key={subField.field}>
                        {value ? String(value) : "—"}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <span className="safety-row-details__dash">—</span>
      )}
    </FieldShell>
  );
}
